<template>
  <div class="p-20 bg-white">
    <div>
      <Button class="m-l-5" :loading="searching" @click="search" type="success" ghost>刷新列表</Button>
    </div>

    <div class="p-t-15">
      <Table :columns="columns" border :data="dataPages.content"></Table>
      <div class="text-r p-15">
        <Page :total="dataPages.totalElements" :current="dataPages.number+1" show-elevator show-total
              :page-size="20" size="small" @on-change="search"></Page>
      </div>
    </div>

    <Modal v-model="modal.show" ok-text="确定" title="预约详情">
      <Group>
        <Cell title="预约编号：" :value="modal.data.code"></Cell>
        <Cell title="申请企业：" :value="modal.data.samr.orgName"></Cell>
        <Cell title="预约银行：" :value="modal.data.freePayer.name"></Cell>
        <Cell title="办理网点：" :value="modal.data.freeLocale.name"></Cell>
        <Cell title="网点地址：" :value="modal.data.freeLocale.addrDetail"></Cell>
        <Cell title="网点电话：" :value="modal.data.freeLocale.phone"></Cell>
        <Cell title="客户经理1姓名：" :value="modal.data.freeLocale.nameManager1"></Cell>
        <Cell title="客户经理1电话：" :value="modal.data.freeLocale.phoneManager1"></Cell>
        <Cell title="客户经理2姓名：" :value="modal.data.freeLocale.nameManager2"></Cell>
        <Cell title="客户经理2电话：" :value="modal.data.freeLocale.phoneManager2"></Cell>
        <Cell title="免费套餐：" :value="modal.data.freePlan.name"></Cell>
        <Cell title="刻章店：" :value="modal.data.company.name"></Cell>
        <Cell title="地址：" :value="modal.data.company.address"></Cell>
        <Cell title="电话：" :value="modal.data.company.phone"></Cell>
      </Group>
    </Modal>
  </div>
</template>

<script>
  import Vue from 'vue'
  import pages from '@tubo/tubo-base/mixins/mixinPages'
  import {api, http} from '@/libs'

  export default {
    mixins: [pages],
    data() {
      let that = this
      return {
        modal: {
          show: false,
          data: {samr:{},freeLocale:{},freePayer:{},freePlan:{},company:{}}
        },
        columns: [
          {
            title: '申请单位名称',
            render: (h, w) => h('div', w.row.samr ? w.row.samr.orgName : '--')
          },
          {
            title: '买单方',
            width: 85,
            render: (h, w) => h('div', w.row.freePayer.name)
          },
          {
            title: '办理网点',
            render: (h, w) => h('div', w.row.freeLocale.name)
          },
          {
            title: '选择套餐',
            width: 85,
            render: (h, w) => h('div', w.row.freePlan.name)
          },
          {
            title: '预约状态',
            width: 85,
            render: (h, w) => h('span', {
              directives: [{
                name: 'dict',
                value: w.row.state,
                arg: 'EntitySealWebFreeReservation_state'
              }]
            })
          },
          {
            title: '操作',
            width: 160,
            render: (h, w) => {
              const buttons = []

              buttons.push(h('Button', {
                props: {type: 'primary', ghost: true, size: 'small'}, style: {marginRight: '5px'},
                on: {
                  click: () => {
                    that.modal.data = w.row
                    that.modal.show = true
                  }
                }
              }, '详情'))

              if (w.row.state === '0') {
                buttons.push(h('Button', {
                  props: {type: 'primary', ghost: true, size: 'small'}, style: {marginRight: '5px'},
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: '取消预约',
                        content: '请确认是否需要取消免费刻章的预约？',
                        onOk: () => {
                          http.post(api.webCusFree.opReservationCancel, {id: w.row.id}).then(payload => {
                            that.changeCurrent(payload)
                          })
                        }
                      })
                    }
                  }
                }, '取消预约'))
              }

              return h('div', buttons)
            }
          }
        ],
      }
    },
    methods: {},
    created() {
      this.searchApi = api.webCusFree.reservation
    }
  }
</script>

<style scoped>

</style>